/* eslint-disable sonarjs/no-duplicate-string */
export const Title = `Serviços`;
export const ProtectLabel = `Proteja o seu produto por muito mais tempo!`;
export const RobberyAndTheftLabel = `Roubo e Furto`;
export const ProtectRobberyAndTheft = `Proteção ${RobberyAndTheftLabel}`;
export const ExtendedWarrantyLabel = `Garantia Estendida Original Ampliada`;
export const PaymentsWayLabel = `Formas de pagamentos`;
export const ProfitsLabels = [`- Mais tempo de garantia além do fabricante`, `- Consertos utilizando peças genuínas`, `- Mais de 3 mil assistências técnicas em todo o Brasil`, `- Concorra a R$ 5.000,00 durante 3 meses`];
export const ServicesPriority = [5, 3, 4];
export const RobberyTerms = [{
  id: 'rs1',
  title: 'SEGURO PROTEÇÃO ROUBO E FURTO QUALIFICADO COM QUEBRA ACIDENTAL',
  content: [{
    text: [{
      content: 'As Condições Gerais desse seguro poderão ser consultadas a qualquer momento, através do site '
    }]
  }, {
    link: 'http://condicoesgerais.bnpparibascardif.com.br/rf',
    text: 'condicoesgerais.bnpparibascardif.com.br/rf'
  }]
}, {
  id: 'rs11',
  title: 'CARACTERÍSTICAS DO SEGURO',
  content: [{
    text: [{
      content: 'Garantir a reposição ou o reparo do bem segurado.'
    }]
  }]
}, {
  id: 'rs2',
  title: 'TIPO DE COBERTURA',
  content: [{
    text: [{
      content: 'Roubo, Furto Qualificado e Quebra Acidental de Aparelhos Móveis'
    }]
  }]
}, {
  id: 'rs3',
  title: 'SINISTROS',
  content: [{
    text: [{
      content: 'Em caso de sinistro, o Segurado deverá comunicar a ocorrência do defeito à Seguradora, através do site '
    }]
  }, {
    link: 'https://luizaseg.acioneseuseguro.com.br/',
    text: 'https://luizaseg.acioneseuseguro.com.br/'
  }, {
    text: [{
      content: ', ou entrar em contato com a Central de Atendimento através do telefone informado abaixo.'
    }]
  }, {
    text: [{
      content: 'Fica estabelecido o prazo de até 30 (trinta) dias para o pagamento de indenização devida pelo presente Contrato de Seguro, contados a partir da entrega de todos os documentos básicos previstos. Caso haja solicitação de nova documentação e/ou informação complementar, o prazo para pagamento do sinistro será suspenso, voltando a correr a partir do dia útil subsequente àquele em que forem completamente atendidas as exigências.'
    }]
  }]
}, {
  id: 'rs4',
  title: 'SORTEIO DE CAPITALIZAÇÃO',
  content: [{
    text: [{
      content: 'Haverá sorteio Mensal durante 3 meses, no valor liquido de R$ 5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do site: www.regulamentos.bnpparibascardif.com.br'
    }]
  }, {
    text: [{
      content: 'Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidoria Icatu Seguros: 0800 286 0047. Modalidade Incentivo. “É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art.3º, I do Código Civil '
    }]
  }, {
    link: 'http://www.icatuseguros.com.br',
    text: 'http://www.icatuseguros.com.br'
  }, {
    text: [{
      content: '. É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.'
    }]
  }]
}, {
  id: 'rs5',
  title: 'EXCLUSÕES GERAIS',
  content: [{
    text: [{
      content: 'Todos os riscos excluídos que constam no bilhete de seguro do bem segurado, também estarão automaticamente excluídos deste seguro. Os danos causados por atos ilícitos dolosos ou por culpa grave equiparável ao dolo, praticados pelo segurado, pelo beneficiário ou representante legal de um ou de outro, estarão excluídos.'
    }]
  }]
}, {
  id: 'rs6',
  title: 'INFORMAÇÕES ADICIONAIS',
  content: [{
    text: [{
      content: 'A contratação do Seguro é opcional e é proibido condicionar desconto no preço do bem à aquisição do seguro; O Segurado deverá guardar o certificado de garantia do fabricante; O Segurado poderá desistir do seguro no prazo de 7 dias corridos a contar da emissão do bilhete, através da Central de Atendimento informada neste documento ou representante de seguro; Caso haja a necessidade de reparo no período de garantia do fabricante, deverá entrar em contato com o fabricante. Número de atendimento do fabricante vide manual de garantia do fabricante.'
    }]
  }]
}, {
  id: 'rs7',
  title: 'CENTRAL DE ATENDIMENTO',
  content: [{
    text: [{
      content: 'SAC (cancelamento, reclamações e informações sobre seguro): 0800 545 4040. '
    }, {
      content: 'Abertura e acompanhamento de sinistro: 3003 4288 (Capitais e regiões metropolitanas) ou 0800 200 0940 (demais localidades). '
    }, {
      content: 'Deficiente auditivo:0800 727 2482 (atendimento todos os dias, 24h). Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br.'
    }]
  }]
}, {
  id: 'rs8',
  title: 'SEGURADORA',
  content: [{
    text: [{
      content: 'Cardif do Brasil Seguros e Garantias S/A, CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, Nº1909, Torre Sul, 8º andar, São Paulo/SP, CEP: 04543-907 ou https://www.bnpparibascardif.com.br/'
    }]
  }]
}, {
  id: 'rs9',
  title: 'CORRETORA',
  content: [{
    text: [{
      content: 'Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706.'
    }]
  }]
}, {
  id: 'rs10',
  title: 'DISPOSIÇÕES GERAIS',
  content: [{
    text: [{
      content: 'Ouvidoria - Finalidade e Forma de Utilização: 0800 727 2482 ou https://www.luizaseg.com.br/. “O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep”. “A adesão ao seguro é opcional”. “O segurado poderá consultar a situação cadastral de seu corretor de seguros, no site www.susep.gov.br, por meio do número de seu registro na SUSEP, nome completo, CNPJ ou CPF”. ”A aceitação do seguro estará sujeita à análise do risco”. “As condições contratuais/regulamento deste produto encontram-se registradas na SUSEP de acordo com o número de processo constante da apólice/proposta e poderão ser consultadas no endereço eletrônico www.susep.gov.br”. “Em atendimento à Lei 12.741/12 informamos que incidem as alíquotas de 0,65% de PIS/Pasep e de 4% de COFINS sobre os prêmios de seguros/as contribuições a planos de caráter previdenciário/os pagamentos destinados a planos de capitalização, deduzidos do estabelecido em legislação específica”. “O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep”. "É dever do intermediário disponibilizar ao cliente formal e previamente à contratação do seguro, o montante de sua remuneração e o prêmio do seguro. A distribuição dos seguros por meio do Magazine Luiza é realizada com exclusividade. Saiba mais sobre a privacidade dos seus dados pessoais e como serão mantidos em segurança: acesse https://www.luizaseg.com.br/lgpd.php;". A FRAUDE CONTRA SEGUROS É CRIME, DENUNCIE (21) 2253-1177 OU 181 - WWW.FENASEG.ORG.BR. Atendimento SUSEP: 0800 021 8484 - Dias úteis das 9:30 às 17:00 Por meio do Acordo Operacional celebrado entre as empresas acima (“ SEGURADORA”) e (“REPRESENTANTE”), a SEGURADORA confere a REPRESENTANTE poderes para: Realizar a oferta e promoção de Seguros, inclusive por meios remotos, em nome da SEGURADORA; Emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA; Orientar e assistir aos corretores de seguros e seus prepostos, se for o caso; Dar apoio logístico e administrativo à SEGURADORA, visando a manutenção dos contratos de seguros e outros serviços, inclusive, controle e processamento de dados das operações pactuadas em nome da SEGURADORA.'
    }]
  }]
}];
export const ExtendedWarrantyTerms = [{
  id: 'ce1',
  title: 'SEGURO DE GARANTIA ESTENDIDA ORIGINAL AMPLIADA',
  content: [{
    text: [{
      content: 'Processo Susep: 15414.900275/2014-64, garantido pela Cardif do Brasil. Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, No 1909, Torre Sul, 8o andar, São Paulo/SP, CEP: 04543-907 ou '
    }]
  }, {
    link: 'http://www.cardif.com.br',
    text: 'www.cardif.com.br'
  }]
}, {
  id: 'ce2',
  title: 'CARACTERÍSTICAS DO SEGURO',
  content: [{
    text: [{
      content: 'Este seguro de Garantia Estendida Original Ampliada tem por objetivo, caso o segurado queira e possua o pagamento do seguro em dia, além de estender a garantia de  fábrica do bem, contemplar as coberturas adicionais de Danos Elétricos e Oxidação.'
    }]
  }]
}, {
  id: 'ce3',
  title: 'TIPO DE COBERTURA',
  content: [{
    text: [{
      content: 'Extensão de Garantia Original.'
    }]
  }]
}, {
  id: 'ce4',
  title: 'SEGURADORA',
  content: [{
    text: [{
      content: 'Cardif do Brasil Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84 com endereço na Avenida Presidente Juscelino Kubitscheck, Nº1909, Torre Sul, 8º andar, São Paulo/SP, CEP: 04543-907 ou www.cardif.com.br.'
    }]
  }]
}, {
  id: 'ce5',
  title: 'REPRESENTANTE DE SEGURO',
  content: [{
    text: [{
      content: 'Magazine Luiza S.A., CNPJ: 47.960.950/0001-21.'
    }]
  }]
}, {
  id: 'ce6',
  title: 'CORRETORA',
  content: [{
    text: [{
      content: 'Viotto Corretora de Seguros e Previdência Ltda, CNPJ: 56.170.061/0001-51 e Registro SUSEP:202069682.'
    }]
  }]
}, {
  id: 'ce7',
  title: 'SORTEIO DE CAPITALIZAÇÃO',
  content: [{
    text: [{
      content: 'Haverá sorteio mensal durante 3 meses, no valor líquido de R$5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do '
    }]
  }, {
    link: 'http://siteregulamentos.bnpparibascardif.com.br',
    text: 'siteregulamentos.bnpparibascardif.com.br.'
  }, {
    text: [{
      content: `Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidora Icatu Seguros: 0800 286 0047, Modalidade Incentivo. "É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3° I do Código Civil".http://www.icatuseguros.com.brÉ proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.`
    }]
  }]
}, {
  id: 'ce8',
  title: 'EXCLUSÕES GERAIS: SITUAÇÕES QUE NÃO SERÃO ATENDIDAS PELO SEU SEGURO.',
  content: [{
    text: [{
      content: `Não estará coberto tudo que estiver previsto ou não abrangido no Certificado de Garantia e/ou no Manual de Garantia de fábrica do bem, inclusive aquilo que deixar de ser garantido e/ou deter a cobertura oferecida durante prazo de garantia do fabricante,exceto os defeitos decorrentes de Danos Elétricos Oxidação. Além dos riscos excluídos descritos acima, também são excluídos deste seguro os atos ilícitos dolosos ou por culpa grave equiparável ao dolo, que agravem intencionalmente o risco, podendo ser considerados fraude, ou má-fé,por ação ou omissão, praticados pelo segurado, pelo beneficiário ou pelo representante de um ou de outro e,caso o segurado seja uma pessoa jurídica, essas exclusões aplicam-se também aos sócios controladores, aos seus dirigentes e administradores legais, aos beneficiários e aos seus respectivos representantes legais. `
    }]
  }]
}, {
  id: 'ce9',
  title: 'EXCLUSÕES ESPECÍFICAS: SITUAÇÕES POR COBERTURA CONTRATADA QUE NÃO SERÃO ATENDIDAS  PELO SEU SEGURO. ',
  content: [{
    text: [{
      content: 'Danos Elétricos'
    }, {
      content: 'a)Fusíveis, resistências de aquecimento, lâmpadas de qualquer tipo, tubos catódicos de equipamentos eletrônicos e quaisquer outros componentes, que,por sua natureza,necessitem de trocas periódicas.'
    }, {
      content: 'b)Perdas,danos ou avarias ao bem segurado por combustão e/ou aquecimento espontâneo;'
    }, {
      content: 'c)Recomposição de registros e documentos, arquivos, softwares de qualquer natureza, bem como seus periféricos, configurações, formatações, backups, disquetes etc. '
    }, {
      content: 'd) Danos causados a programas de informática qualquer tipo,ficando entendido,no entanto,que nos casos de perda total de microcomputadores em virtude de evento coberto, os programas que acompanharam o equipamento quando da aquisição estarão garantidos,exceto os programas opcionalmente adquiridos.'
    }, {
      content: 'd) Danos causados a programas de informática qualquer tipo,ficando entendido,no entanto,que nos casos de perda total de microcomputadores em virtude de evento coberto, os programas que acompanharam o equipamento quando da aquisição estarão garantidos,exceto os programas opcionalmente adquiridos.'
    }, {
      content: 'Oxidação:'
    }, {
      content: 'a)Qualquer defeito coberto provocado intencionalmente;'
    }, {
      content: 'b)Partes,peças e componentes que são consumíveis ou sofram desgaste natural, independente da origem do problema; '
    }, {
      content: 'c) Produto cujo número de identificação, do chassi ou de série tenha sido removido ou adulterado;'
    }, {
      content: 'd) Manchas, desgastes ou de outras falhas consequentes da aplicação de produtos impermeabilizantes; '
    }, {
      content: 'e) Danos estéticos como riscos, quebras, trincas, amassamentos, arranhaduras etc.), mesmo decorrentes de Danos Elétricos.'
    }]
  }]
}, {
  id: 'ce10',
  title: 'SINISTROS',
  content: [{
    text: [{
      content: `Em caso de sinistro, o Segurado deverá comunicar a ocorrência do defeito à Seguradora, por meio do site www.acioneseuseguro.com.br, ou entrar em contato com  a Central de Atendimento por meio do telefone informado abaixo. Nesta ocasião, o segurado receberá um número de sinistro, que deverá ser informado à assistência  técnica indicada.A seguradora terá até 30 dias corridos para concluir o atendimento, a contar da entrega do bem segurado à assistência técnica pelo segurado, acompanhado do Bilhete de Seguro, Documento Fiscal de Aquisição do Bem Segurado, CPF ou outro documento de identificação.Se o bem segurado apresentar  algum defeito funcional (chamado daqui por diante apenas de “defeito’’) durante a vigência do seguro, a indenização se dará por meio do reparo do bem, que será feito pela  assistência técnica. O seguro cobre o valor das peças de reposição e o custo da mão-de-obra. Caso o bem não possa ser consertado, será feita a sua reposição por outro  igual ou com funcionalidades semelhantes, que pode ser novo ou recondicionado. Se não for possível nem o reparo e nem a reposição do bem, o segurado receberá o  pagamento do valor que pagou por ele, de acordo com a nota fiscal de compra. `
    }]
  }]
}, {
  id: 'ce11',
  title: 'CENTRAL DE ATENDIMENTO',
  content: [{
    text: [{
      content: 'Central de atendimento: SAC (Cancelamentos,reclamações e informações do seguro): 0800 545 4040. Abertura e Acompanhamento de Sinistros: 3003 4288 (Capitais e regiões metropolitanas) ou 0800 200 0940 (Demais localidades). Deficiente Auditivo: 0800 725 0645,atendimento todos os dias, 24 horas. Ouvidoria Cardif: 0800 727 2482, atendimento em dias úteis, das 9h às 18h (horário de Brasília) exceto feriados, ou ouvidoria.bnpparibascardif.com.br'
    }]
  }]
}, {
  id: 'ce12',
  title: 'DISPOSIÇÕES GERAIS',
  content: [{
    text: [{
      content: `Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br e também www.consumidor.gov.br. A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago. É proibido condicionar desconto no preço do bem à aquisição do seguro. A comercialização de seguros é fiscalizada pela SUSEP. www.susep.gov.br – 0800 021 8484. O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep. É dever do intermediário disponibilizar ao cliente formal e previamente à contratação do seguro, o montante de sua remuneração e o prêmio do seguro. A distribuição dos seguros por meio do Magazine Luiza é realizada com exclusividade. Saiba mais sobre a privacidade dos seus dados pessoais e como serão mantidos em segurança: acesse bnpparibascardif.com.br/lei-geal-de-protecao-de-dados. O segurado poderá consultar a situação cadastral de seu corretor de seguros, no site www.susep.gov.br por meio do número de seu registro na SUSEP, nome completo, CNPJ ou CPF. O segurado deverá guardar o certificado de garantia do fabricante. Caso haja a necessidade de reparo no período de garantia do fabricante, deverá entrar em contato com o fabricante. Número de atendimento do fabricante vide manual de garantia do fabricante. As condições contratuais/regulamento deste produto encontram-se registradas na SUSEP de acordo com o número de processo constante da apólice/proposta e poderão ser consultadas no endereço eletrônico www.susep.gov.br. Em atendimento à Lei 12.741/12 informamos que incidem as alíquotas de 0,65% de PIS/Pasep e de 4% de COFINS sobre os prêmios de seguros/as contribuições a planos de caráter previdenciário/os pagamentos destinados a planos de capitalização, deduzidos do estabelecido em legislação específica. A FRAUDE CONTRA SEGUROS É CRIME, DENUNCIE (21) 2253-1177 OU 181 - WWW.FENASEG.ORG.BR. Atendimento SUSEP:0800 021 8484 - Dias úteis das 9:30 às 17:00. Por meio do Acordo Operacional celebrado entre as empresas acima ("SEGURADORA") e ("REPRESENTANTE"), a SEGURADORA confere a REPRESENTANTE poderes para: Realizar a oferta e promoção de Seguros, inclusive por meios remotos, em nome da SEGURADORA; Recepcionar propostas de seguros e/ou emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA; Recepcionar propostas de seguros e/ou emitir bilhetes de seguro em nome da SEGURADORA e entregá-lo ao segurado; Coletar e fornecer à SEGURADORA os dados cadastrais e de documentação de proponentes, segurados, beneficiários e corretores de seguros e seus prepostos; Recolher os prêmios de Seguro, em nome da SEGURADORA, e repassá-los integralmente à SEGURADORA; Orientar e assistir aos segurados e seus beneficiários, no que compete aos contratos de Seguro, inclusive por meios remotos, em nome da SEGURADORA;`
    }]
  }]
}];
export const ExtendedWarrantyRegulationTitle = `${ExtendedWarrantyLabel}`;
export const RobberyRegulationTitle = `Seguro ${RobberyAndTheftLabel} Qualificado`;
export const RobberyRegulation = 'Seguro Garantia Estendida Original, orientamos a leitura das condições gerais do seguro no link www.luizaseg.com.br. Seguro garantido pela Luizaseg Seguros S/A, CNPJ: 07.746.953/0001-42, Processo Susep Nº 15414.900276/2014-17. Representante de Seguro: Magazine Luiza S/A, CNPJ 47.960.950/0001-21. Corretora: Viotto Corretora de Seguros e Previdência LTDA, CNPJ 56.170.061/0001-51, Registro SUSEP 10.0059706. “Adesão Opcional”. "A  contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago." "É proibido condicionar desconto no preço do bem à aquisição do seguro." Título de Capitalização garantido Capitalização: Icatu Capitalização S.A., CNPJ: 74.267.170/0001-73 Processo SUSEP: 15414.900051/2018-86. Ouvidoria Icatu Seguros: 0800 286 0047. Consulte o regulamento do sorteio no site: "http://www.icatuseguros.com.br". Modalidade: Incentivo. Prêmio no valor líquido de R$ 5.062,50. Promoção válida por 3 meses. Sorteios: Mensais a partir do último sábado do mês subsequente a adesão.  Consulte o regulamento no link regulamentos.bnpparibascardif.com.br.  "É proibida a venda de títulos de capitalização a menores de dezesseis ano - Art.3º, I do Código Civil".  "A comercialização de seguro é fiscalizada pela Susep. www.susep.gov.br - 0800 021 8484". "A aprovação do Plano pela Susep não implica, por parte da Autarquia, em incentivo ou recomendação à sua aquisição. "Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria : 0800 727 2482 - Dias úteis, das 9h as 18 horas (horário de Brasilia) exceto feriados ou bnpparibascardif.com.br/ouvidoria.';
export const ExtendedWarrantyRegulation = `Processo Susep: 15414.900275/2014-64, garantido pela Cardif do Brasil. Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84, com endereço na Avenida Presidente Juscelino Kubitscheck, No 1909, Torre Sul, 8o andar, São Paulo/SP, CEP: 04543-907 ou www.cardif.com.br. Orientamos a leitura das condições gerais no link https://bnpparibascardif.com.br/condicoes-gerais. REPRESENTANTE DE SEGURO Magazine Luiza S.A., CNPJ: 47.960.950/0001-21. CORRETORA
  Viotto Corretora de Seguros e Previdência Ltda, CNPJ: 56.170.061/0001-51 e Registro SUSEP:202069682.
  A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos com a devolução integral do valor pago. É proibido condicionar desconto no preço do bem à aquisição do seguro.
  Haverá sorteio mensal durante 3 meses, no valor líquido de R$5.062,50, realizado pela Loteria Federal. A participação ocorrerá por meio do seu Número da Sorte expresso no Bilhete de Seguro, desde que o pagamento do seguro esteja em dia. O regulamento da capitalização pode ser consultado a qualquer tempo através do siteregulamentos.bnpparibascardif.com.br. Icatu Capitalização S.A., CNPJ: 74.267.170/1000-73, Processo SUSEP: 15414.900393/2019-87, Ouvidora Icatu Seguros: 0800 286 0047, Modalidade Incentivo. "É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3° I do Código Civil".http://www.icatuseguros.com.br.
  É proibida a venda de títulos de capitalização a menores de dezesseis anos - Art. 3o, I do Código Civil.  A comercialização de seguros é fiscalizada pela SUSEP. www.susep.gov.br – 0800 021 8484.  O registro do produto é automático e não representa aprovação ou recomendação por parte da Susep. Caso não esteja satisfeito com a resposta fornecida pelo SAC, entre em contato com a Ouvidoria: 0800 727 2482 - Dias úteis, das 9h às 18 horas (horário de Brasília) exceto feriados ou acesse ouvidoria.bnpparibascardif.com.br e também www.consumidor.gov.br.`;
export const ConciseMessage = `Ao clicar em contratar serviço e ir para sacola você aceita as condições do seguro`;
export const Conditions = `${RobberyAndTheftLabel} e Forma de pagamento`;
export const PaymentsWayTerms = [{
  id: 'pw1',
  title: 'Termo de Autorização de cobrança de Prêmio de Seguro',
  content: [{
    text: [{
      content: 'Eu, proponente '
    }, {
      content: '{description} '
    }, {
      content: 'autorizo que o pagamento do prêmio de seguro no valor de '
    }, {
      content: '{totalPrice} ',
      bold: true
    }, {
      content: 'seja realizado em conjunto com o pagamento do(s) produto(s)/serviço(s) ora adquirido(s).'
    }]
  }]
}, {
  id: 'pw2',
  content: [{
    text: [{
      content: 'Início e Término da vigência do seguro: ',
      bold: true
    }, {
      content: 'Data especificada no Bilhete de Seguro que você receberá após a conclusão da compra, quando o Termo estará disponível com os dados completos, refletindo sua opção prévia e autorização de cobrança de prêmio.'
    }]
  }]
}, {
  id: 'pw3',
  content: [{
    text: [{
      content: 'Declaro ter prévia ciência das informações mínimas obrigatórias disponibilizadas antes da contratação do seguro acompanhadas da íntegra das Condições Gerais do presente Seguro e tenho conhecimento que também poderei consultá-la a qualquer momento através do site www.luizaseg.com.br. Declaro também que foram integralmente cumpridas as regras de conduta que devem ser praticadas pelos corretores de seguros e demais intermediários no relacionamento com o cliente, previstas na legislação vigente.'
    }]
  }]
}, {
  id: 'pw4',
  content: [{
    text: [{
      content: 'Notas :',
      bold: true
    }, {
      content: 'O segurado poderá desistir do seguro contratado no prazo de 7 (sete) dias corridos a contar da assinatura da proposta, no caso de contratação por apólice individual, ou da emissão do bilhete, no caso de contratação por bilhete, ou do efetivo pagamento do prêmio, o que ocorrer por último. No caso de pagamento de prêmio fracionado, considera-se o pagamento da primeira parcela como o efetivo pagamento.'
    }]
  }]
}, {
  id: 'pw5',
  financialService: 'extendedWarranty',
  content: [{
    text: [{
      content: 'Seguradora: Luizaseg Seguros S/A. CNPJ: 07.746.953/0001-42. Código Susep: 0206-2. Processo Susep: 15414.900276/2014-17. Ramo(s): 0195. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{extendedWarrantyPercentage} - '
    }, {
      content: '{extendedWarrantyAmount} '
    }, {
      content: '"A Magazine Luiza possui participação de 50% na Luizaseg Seguros S.A." Corretora: Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706. Remuneração: 0,03%.'
    }]
  }]
}, {
  id: 'pw6',
  financialService: 'certainExchange',
  content: [{
    text: [{
      content: 'Seguradora: Luizaseg Seguros S/A. CNPJ: 07.746.953/0001-42. Código Susep: 0206-2. Processo Susep: 15414.900276/2014-17. Ramo(s): 0195. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{certainExchangePercentage} - '
    }, {
      content: '{certainExchangeAmount} '
    }, {
      content: '"A Magazine Luiza possui participação de 50% na Luizaseg Seguros S.A." Corretora: Viotto Corretora de Seguros e Previdência Ltda. CNPJ: 56.170.061/0001-51. Registro SUSEP: 10.0059706. Remuneração: 0,03%.'
    }]
  }]
}, {
  id: 'pw7',
  financialService: 'robberyAndTheft',
  content: [{
    text: [{
      content: 'Seguradora: Cardif do Brasil Seguros e Garantias S.A. CNPJ: 08.279.191/0001-84 Código SUSEP: 0293-3 Processo SUSEP: 15414.900738/2014-98 Ramo: 71. Representante de Seguro: Magazine Luiza S/A CNPJ: 47.960.950/0001-21. Remuneração: '
    }, {
      content: '{robberyAndTheftPercentage} - '
    }, {
      content: '{robberyAndTheftAmount} '
    }, {
      content: 'Corretora: Viotto Corretora de Seguros e Previdência LTDA. CNPJ: 56.170.061/0001-51 Registro SUSEP: 100059706. Remuneração: 0,03%.'
    }]
  }]
}];